import './update-balance.modal.scss';

export default function UpdateBalanceModal($scope, close, balance, $gl) {
  'ngInject';

  balance.reason = '';
  $scope.balance = balance;

  $scope.ok = (form) => {
    if (form.$valid) {
      $gl.show();

      const request = {
        amount: $scope.balance.amount,
        creditLimit: $scope.balance.creditLimit,
        reason: $scope.balance.reason
      }

      close(request);
    }
  }

  $scope.close = () => {
    close(false);
  }
}